<div class="modal-header" [class.error]="error" [class.success]="!error">
  @if (!error) {
    <i class="fal fa-info-circle"></i>
  }
  @if (error) {
    <i class="fal fa-exclamation-circle"></i>
  }
  <h4 class="modal-title">{{(error ? "modal.warning" : "modal.information") | translate}}</h4>
  <button type="button" class="close" aria-label="Close" mat-dialog-close>
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="scroll">
    @if (stats && !stats?.isAccepted) {
      <div class="section">
        @if (stats?.recordsToUpdate === 0) {
          <span>{{'fuelCard.fileCorrect' | translate }}</span>
        }
        @if (stats?.recordsToUpdate > 0) {
          <span>{{'fuelCard.fileCorrectWithDuplicatedEvents' | translate }}</span>
          <span class="red-text">{{'fuelCard.overwriteEvent' | translate }}</span>
        }
      </div>
      <div class="d-flex justify-content-center mb-2">
        <button type="button" class="btn button-secondary-important me-3" (click)="accept()">
          {{ 'fuelCard.accept' | translate }}
        </button>
        <button type="button" class="btn button-primary" (click)="activeModal.close()">
          {{ 'fuelCard.cancel' | translate }}
        </button>
      </div>
    }
    @if (stats && stats?.isAccepted) {
      <div class="section">
        <span>{{'fuelCard.importedRefuelingEvents' | translate }}: {{stats?.filteredFuelingsCount}}</span>
        <span>{{'fuelCard.RefuelingEventsRequiringEditing' | translate }}: <span
        class="yellow-text">{{stats?.filteredFuelingsMatchedToUnitsCount}}</span></span>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-link" (click)="activeModal.close()">
          {{ 'ok' | translate }}
        </button>
      </div>
    }
    @if (error) {
      <div class="section">
        <pre>{{error?.errorMessage}}</pre>
      </div>
    }
  </div>
</div>
